import { render, staticRenderFns } from "./RecentAccounts.vue?vue&type=template&id=849a349e&"
import script from "./RecentAccounts.vue?vue&type=script&lang=js&"
export * from "./RecentAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports